// -----------DONT CHANGE ANY OF THE CODE BELOW----------------------------
import {Component, HostListener, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import { PagesService } from './pages/home/pages.service';
import { UserIdleService } from 'angular-user-idle';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(private router: Router,private pageService:PagesService,private _router: Router,private userIdle: UserIdleService) {
    this.resetTimeout();
   }
  currentUser: any;
  apiCallInterval:any
  private timeoutId: any;
  ngOnInit() {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  this.pageService.refreshHandle(this.currentUser.userName,this.currentUser.loginDetailId).subscribe(x=>{

  })
  this.userIdle.resetTimer();
  this.userIdle.startWatching();//will logout after 10 mins of inactivity
  this.userIdle.onTimerStart().subscribe(

      count => {
          // console.log('timeout', count)
          // console.log('timeout', this.currentUser.userName)
          if (count == 8 || count == 9) {
              this.pageService.userLogOut(this.currentUser.userName).subscribe((x:any)=>{
                  sessionStorage.removeItem('currentUser');
                  this._router.navigate(['/auth/login']);

               },(error:any)=>{
                  if(error.status == 200){
                      sessionStorage.removeItem('currentUser');
                      this._router.navigate(['/auth/login']);


                  }
                 
               })
              
              return;
          }

      });
  this.userIdle.onTimeout().subscribe(count => { this.userIdle.stopWatching(); this.userIdle.stopTimer() });

  this.apiCallInterval = setInterval(() => {
    let currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    // Perform the API call
    // console.log('api works---------------------------------------------------')
    this.pageService.checkUserLogout(currentUser.loginDetailId).subscribe(
      (response) => {
         // Handle the API response
      },
      (err: any) => {
        if (err.status === 403) {
          console.log('app component')
          // this.pageService.userLogOut(currentUser.userName).subscribe((x:any)=>{ }) 
          sessionStorage.removeItem('currentUser');
          this._router.navigate(['/auth/login']);
          Swal.fire('','Someone has logged in with the Same User Name','warning')
        }
        // console.log('logged out sucessfully---------------------------------------------------')
      }
    );
  }, 10000); // Trigger every 60 seconds

  const uniqueIdentifier = sessionStorage.getItem('appUniqueIdentifier');

  if (uniqueIdentifier) {
    // Handle duplicate tab: Redirect to a specific route or show an error message
    // For example, redirect to the login route
    this.router.navigate(['/auth/login']);
  } else {
    // Set a unique identifier in sessionStorage
    sessionStorage.setItem('appUniqueIdentifier', 'your_unique_identifier_here');
  }

}
@HostListener('window:beforeunload')
clearSessionStorage() {
  // Clear sessionStorage when the window is about to unload
  sessionStorage.removeItem('appUniqueIdentifier');
}
// @HostListener('window:beforeunload', ['$event'])
//   onBeforeUnload(event:any) {
//     // return false;
//     event.preventDefault();
//     event.returnValue = false;
// }
// @HostListener('window:beforeunload', ['$event']) 
//   onUnload(event:any) {
//   console.log('wathapppng',document.visibilityState)
//    if(document.visibilityState === 'hidden'){
//     this.pageService.userLogOut(this.currentUser.userName).subscribe((x:any)=>{ }) 
//     sessionStorage.removeItem('currentUser');
//     this._router.navigate(['/auth/login']);
//    }
// }
  @HostListener('window:unload', ['$event'])
  onBeforeUnload(event:any) {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.pageService.userLogOut(this.currentUser.userName).subscribe((x:any)=>{ }) 
        //  sessionStorage.removeItem('currentUser');
         this._router.navigate(['/auth/login']);
  }
  @HostListener('window:mousemove')
  @HostListener('window:keydown')
    resetTimeout() {
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => this.logout(), 15 * 60 * 1000); // 15 minutes
    }
  logout() {
    this.pageService.userLogOut(this.currentUser.userName).subscribe((x:any)=>{ }) 
         sessionStorage.removeItem('currentUser');
         this._router.navigate(['/auth/login']);
  }
  }
